import {
  IonBackButton,
  IonButton,
  IonButtons,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardSubtitle,
  IonCardTitle,
  IonCol,
  IonContent,
  IonGrid,
  IonHeader,
  IonIcon,
  IonLabel,
  IonList,
  IonListHeader,
  IonLoading,
  IonMenuButton,
  IonModal,
  IonPage,
  IonRefresher,
  IonRefresherContent,
  IonRow,
  IonSkeletonText,
  IonTitle,
  IonToolbar,
  RefresherEventDetail,
  useIonLoading,
  useIonViewDidEnter,
  IonInfiniteScroll,
  IonInfiniteScrollContent,
  IonFooter,
  IonItem,
  IonSpinner,
  IonSegment,
  IonSegmentButton,
} from "@ionic/react";
import { useHistory, useLocation, useParams } from "react-router";

import Navbar from "../../../components/WebApp/Navbar/Navbar";
import PubSub from "../../../lib/PubSub";
import { useEffect, useMemo, useRef, useState } from "react";

import StorageUtils from "../../../lib/StorageUtils";
import API from "../../../lib/API";
import StringUtils from "../../../lib/StringUtils";
import moment from "moment";
import Constants from "../../../lib/Constants";
import Event from "../../../lib/Event";
import InlineSchedulingModal from "../../../components/Scheduler/SchedulingCalendar/InlineSchedulingModal";
import InlineReschedulingModal from "../../../components/Scheduler/SchedulingCalendar/InlineReschedulingModal";
import AppointmentInformation from "../../../components/Scheduler/AppointmentInformation/AppointmentInformation";
import DateUtils from "../../../lib/DateUtils";
import UpcomingOrderCard from "../../../components/AccountManagement/UpcomingOrderCard/UpcomingOrderCard";
import ReviewOrderCard from "../../../components/AccountManagement/ReviewOrderCard/ReviewOrderCard";
import _ from "underscore";
import MealDetailContent from "../../../components/MealDetailContent";
import { Capacitor } from "@capacitor/core";
import { Geolocation } from "@capacitor/geolocation";
import onboardLocations from "../../../assets/img/icons/locations.svg";
import {
  checkmarkCircle,
  closeCircleOutline,
  options,
  search,
  searchOutline,
} from "ionicons/icons";
import LocationSearchInputV2 from "../../../components/Map/LocationSearchInputV2";
import MapUtils from "../../../lib/MapUtils";
import SegmentUtils from "../../../lib/SegmentUtils";
import { geocodeByAddress, getLatLng } from "react-places-autocomplete";
import onboardPLNPlus from "../../../assets/img/icons/onboard_plnplus.svg";
import PLNPlusUpsellModal from "../../../components/PLNPlusUpsellModal/PLNPlusUpsellModal";
import MealDetailModalV2 from "../../../components/MealDetailModalV2";

const AppUserPLNPlusUpsellPage: React.FC<{
  nativeMode?: boolean;
  showBackButton?: boolean;
  next: () => void;
  previous: () => void;
  hasNext: boolean;
  hasPrevious: boolean;
  step: any;
}> = ({
  nativeMode = false,
  showBackButton = false,
  next,
  previous,
  hasNext,
  hasPrevious,
  step,
}) => {
  const history = useHistory();
  const [loading, setLoading] = useState(
    Capacitor?.isNativePlatform() ? true : false,
  );
  const [modalOpen, setModalOpen] = useState(false);
  const pageRef = useRef();

  const [lead, setLead] = useState<any>(null);

  const [user, setUser] = useState<any>(null);
  const [store, setStore] = useState<any>(null);
  const [submitting, setSubmitting] = useState<boolean>(false);

  const [mealInfoModalID, setMealInfoModalID] = useState<string>(
    "plnplus-upsell-meal-info",
  );

  const [filterOption, setFilterOption] = useState<string>("all");

  const loadUser = async () => {
    return new Promise(async (resolve, reject) => {
      setLoading(true);

      let user = await StorageUtils.get("user_customer");

      if (user) {
        setUser(user);
      }

      let store = await StorageUtils.get("user_store");

      if (store) {
        setStore(store);
      }

      setTimeout(() => {
        API.getAccount()
          .then(
            async (data: any) => {
              setUser(data?.data?.data?.user);

              PubSub.publish("userUpdated", data?.data?.data?.user);

              if (data?.data?.data?.store) {
                setStore(data?.data?.data?.store);

                await StorageUtils.set("user_store", data?.data?.data?.store);
              } else {
                setStore(null);
                await StorageUtils.set("user_store", null);
              }

              resolve(data?.data?.data?.user);
            },
            async (e) => {
              let user: any = await StorageUtils.get("user_customer");
              let store: any = await StorageUtils.get("user_store");

              setUser(user ? user : null);
              setStore(store ? store : null);

              reject();
            },
          )
          .finally(() => {
            setLoading(false);
          });
      }, 50);
    });
  };

  const loadPLNPlusOptions = async () => {
    setLoading(true);

    API.createOrUpdateLead(user?.email, null, "Website: Visit", {
      storeID: store?._id,
      name: user?.name ? user?.name : null,
      phone: user?.phone ? user?.phone : null,
    })
      .then((data: any) => {
        let lead = data?.data?.data?.lead;

        if (lead) {
          console.log(lead);

          setLead(lead);
        }

        setModalOpen(true);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useIonViewDidEnter(() => {
    PubSub.publish("mobileScreenChange");

    loadUser();

    setMealInfoModalID("plnplus-upsell-meal-info" + Math.random());

    console.log("ionViewDidEnter");
  }, []);

  return (
    <IonPage ref={pageRef}>
      {nativeMode ? (
        <>
          <IonHeader>
            <IonToolbar className="pln-native-toolbar">
              {hasPrevious ? (
                <IonButtons slot="start">
                  <IonBackButton></IonBackButton>
                </IonButtons>
              ) : null}
              <IonTitle>Explore PLN+</IonTitle>
            </IonToolbar>
          </IonHeader>
        </>
      ) : (
        <Navbar
          showBackButton={hasPrevious}
          actionButton={<></>}
          showMenuButton={false}
          pageName={"Explore PLN+"}
          onGoBack={() => {
            history.goBack();
          }}
        ></Navbar>
      )}

      <IonContent className="bg-white">
        <div className="ion-padding pln-onboarding-container">
          <div className="text-center">
            <div className="rounded w-full min-h-[300px] max-h-[300px] sm:max-h-[350px] mt-[1rem] mb-[1.5rem] flex justify-center">
              <img
                src={onboardPLNPlus}
                alt="PLN+"
                className="w-auto h-full mx-auto max-h-[300px] sm:max-h-[350px] object-contain"
              />
            </div>

            <h2 className="font-medium font-[SourceSerif] text-2xl mb-[0.5rem]">
              Level Up With PLN+
            </h2>

            <p className="" style={{ fontSize: 18 }}>
              Take your results beyond the counter. As a PLN+ member, you’ll
              unlock coaching, progress tracking, and exclusive savings that
              keep you on track every step of the way.
            </p>

            <div className="py-4">
              <div className="text-center text-xl font-medium font-[SourceSerif]">
                Membership Benefits Include:
              </div>
              <div className="my-3 text-center p-3 border rounded-lg">
                <div className="flex justify-center items-center mb-2.5">
                  <div className="flex justify-center rounded-full items-center h-[50px] w-[50px] bg-primary">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="h-6 w-6 text-white"
                    >
                      <path d="M12 13V2l8 4-8 4" />
                      <path d="M20.561 10.222a9 9 0 1 1-12.55-5.29" />
                      <path d="M8.002 9.997a5 5 0 1 0 8.9 2.02" />
                    </svg>
                  </div>
                </div>
                <div className="text-lg font-[SourceSerif]">
                  Goal-Setting Session With a Coach
                </div>
                <div className="text-base mt-1">
                  Sit down with one of our trained coaches to map out your goals
                  and create a simple game plan that works for you.
                </div>
              </div>
              <div className="my-3 p-3 border rounded-lg text-center">
                <div className="flex justify-center items-center mb-2.5">
                  <div className="flex justify-center rounded-full items-center h-[50px] w-[50px] bg-primary">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="h-6 w-6 text-white"
                    >
                      <path d="M19.414 14.414C21 12.828 22 11.5 22 9.5a5.5 5.5 0 0 0-9.591-3.676.6.6 0 0 1-.818.001A5.5 5.5 0 0 0 2 9.5c0 2.3 1.5 4 3 5.5l5.535 5.362a2 2 0 0 0 2.879.052 2.12 2.12 0 0 0-.004-3 2.124 2.124 0 1 0 3-3 2.124 2.124 0 0 0 3.004 0 2 2 0 0 0 0-2.828l-1.881-1.882a2.41 2.41 0 0 0-3.409 0l-1.71 1.71a2 2 0 0 1-2.828 0 2 2 0 0 1 0-2.828l2.823-2.762" />
                    </svg>
                  </div>
                </div>
                <div className="text-lg font-[SourceSerif]">
                  Biweekly Coaching Sessions
                </div>
                <div className="text-base mt-1">
                  Check in one on one with your coach every two weeks for
                  motivation, accountability, and guidance.
                </div>
              </div>
              <div className="my-3 p-3 border rounded-lg text-center">
                <div className="flex justify-center items-center mb-2.5">
                  <div className="flex justify-center rounded-full items-center h-[50px] w-[50px] bg-primary">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="h-6 w-6 text-white"
                    >
                      <path d="M22 12h-2.48a2 2 0 0 0-1.93 1.46l-2.35 8.36a.25.25 0 0 1-.48 0L9.24 2.18a.25.25 0 0 0-.48 0l-2.35 8.36A2 2 0 0 1 4.49 12H2" />
                    </svg>
                  </div>
                </div>
                <div className="text-lg font-[SourceSerif]">
                  Free Progress Tracking Scans
                </div>
                <div className="text-base mt-1">
                  See real results with free InBody scans that track your
                  progress over time.
                </div>
              </div>
              <div className="my-3 p-3 border rounded-lg text-center">
                <div className="flex justify-center items-center mb-2.5">
                  <div className="flex justify-center rounded-full items-center h-[50px] w-[50px] bg-primary">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="h-6 w-6 text-white"
                    >
                      <path d="M17 21a1 1 0 0 0 1-1v-5.35c0-.457.316-.844.727-1.041a4 4 0 0 0-2.134-7.589 5 5 0 0 0-9.186 0 4 4 0 0 0-2.134 7.588c.411.198.727.585.727 1.041V20a1 1 0 0 0 1 1Z" />
                      <path d="M6 17h12" />
                    </svg>
                  </div>
                </div>
                <div className="text-lg font-[SourceSerif]">
                  Personalized Meal Plans
                </div>
                <div className="text-base mt-1">
                  Get a tailored meal plan that fits your lifestyle and choose
                  from over 24 meal options weekly.
                </div>
              </div>
              <div className="my-3 p-3 border rounded-lg text-center">
                <div className="flex justify-center items-center mb-2.5">
                  <div className="flex justify-center rounded-full items-center h-[50px] w-[50px] bg-primary">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="h-6 w-6 text-white"
                    >
                      <path d="M16 10a4 4 0 0 1-8 0" />
                      <path d="M3.103 6.034h17.794" />
                      <path d="M3.4 5.467a2 2 0 0 0-.4 1.2V20a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6.667a2 2 0 0 0-.4-1.2l-2-2.667A2 2 0 0 0 17 2H7a2 2 0 0 0-1.6.8z" />
                    </svg>
                  </div>
                </div>
                <div className="text-lg font-[SourceSerif]">
                  Save Big On Shakes & Supplements
                </div>
                <div className="text-base mt-1">
                  Get an extra 10% off on any additional items you purchase
                  while you're a member.
                </div>
              </div>
              <div className="my-3 p-3 border rounded-lg text-center">
                <div className="flex justify-center items-center mb-2.5">
                  <div className="flex justify-center rounded-full items-center h-[50px] w-[50px] bg-primary">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="h-6 w-6 text-white"
                    >
                      <path d="M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2.426 2.426 0 0 0 3.42 0l6.58-6.58a2.426 2.426 0 0 0 0-3.42z" />
                      <circle cx="7.5" cy="7.5" r=".5" fill="currentColor" />
                    </svg>
                  </div>
                </div>
                <div className="text-lg font-[SourceSerif]">
                  Referral Rewards
                </div>
                <div className="text-base mt-1">
                  Earn an extra $20 off your membership each time you refer
                  friends & family.
                </div>
              </div>
            </div>
          </div>
        </div>
      </IonContent>
      <IonFooter>
        <IonToolbar
          className={`pln-native-toolbar-footer ${
            !Capacitor.isNativePlatform() ? "web" : ""
          }`}
        >
          <IonButton
            onClick={() => {
              loadPLNPlusOptions();
            }}
            disabled={loading}
            expand="block"
            style={{ height: "50px" }}
            mode={
              Capacitor.isNativePlatform()
                ? Capacitor.getPlatform() == "ios"
                  ? "ios"
                  : "md"
                : "ios"
            }
          >
            {loading ? <IonSpinner name="dots" /> : "Explore PLN+ Plans"}
          </IonButton>
          <IonButton
            onClick={async () => {
              next();
            }}
            expand="block"
            color="dark"
            disabled={loading}
            fill="clear"
            mode={
              Capacitor.isNativePlatform()
                ? Capacitor.getPlatform() == "ios"
                  ? "ios"
                  : "md"
                : "ios"
            }
          >
            Maybe Later
          </IonButton>
        </IonToolbar>
      </IonFooter>
      <PLNPlusUpsellModal
        presentingElement={pageRef?.current}
        user={user}
        store={store}
        open={modalOpen}
        setOpen={setModalOpen}
        mealInfoModalID={mealInfoModalID}
        onSubmitting={() => {
          setLoading(true);
        }}
        onSignupComplete={() => {
          setModalOpen(false);

          setLoading(true);

          loadUser().then(() => {
            history.push("/onboarding/onboarding_plnplus_postsignup/welcome");
          });
        }}
        lead={lead}
      ></PLNPlusUpsellModal>
      <MealDetailModalV2
        id={mealInfoModalID}
        showQuantity={true}
        presentingElement={pageRef?.current}
        nativeMode={Capacitor.isNativePlatform()}
      />
    </IonPage>
  );
};

export default AppUserPLNPlusUpsellPage;
